{
    "name": "dls-frontend",
    "version": "1.0.19",
    "scripts": {
        "ng": "ng",
        "ng-openapi-gen": "ng-openapi-gen",
        "ng-openapi-gen-v3": "ng-openapi-gen --config ng-openapi-gen-v3.json",
        "ng-openapi-gen-all": "npm run ng-openapi-gen && npm run ng-openapi-gen-v3",
        "swagger-get-sia": "node generate-api-usage/sia/swagger-get-sia-proxy.js",
        "swagger-get-sia:dev": "node generate-api-usage/sia/swagger-get-sia-proxy.js dev",
        "swagger-get-sia:prod": "node generate-api-usage/sia/swagger-get-sia-proxy.js prod",
        "swagger-get-sia:test": "node generate-api-usage/sia/swagger-get-sia-proxy.js test",
        "swagger-get-sia:apitest": "node generate-api-usage/sia/swagger-get-sia-proxy.js apitest",
        "ng-openapi-gen-sia": "npm run swagger-get-sia && ng-openapi-gen --config generate-api-usage/sia/ng-openapi-gen.json",
        "generate:api:sia:dev": "npm run swagger-get-sia:dev && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.dev.json",
        "generate:api:sia:prod": "npm run swagger-get-sia:prod && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.prod.json",
        "generate:api:sia:test": "npm run swagger-get-sia:test && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.test.json",
        "generate:api:sia:apitest": "npm run swagger-get-sia:apitest && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.apitest.json",
        "generate:api:dev": "ng-openapi-gen -c openapi-configs/openapi-main.dev.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.dev.json",
        "generate:api:prod": "ng-openapi-gen -c openapi-configs/openapi-main.prod.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.prod.json",
        "generate:api:test": "ng-openapi-gen -c openapi-configs/openapi-main.test.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.test.json",
        "generate:api:apitest": "ng-openapi-gen -c openapi-configs/openapi-main.apitest.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.apitest.json",
        "generate:api:localDev": "ng-openapi-gen -c openapi-configs/openapi-main.localDev.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.localDev.json",
        "start": "ng serve --host=0.0.0.0 --configuration=development",
        "start:dev": "npm run generate:api:dev && ng serve --host=0.0.0.0 --configuration=development",
        "start:prod": "npm run generate:api:prod && ng serve --host=0.0.0.0 --configuration=prod",
        "start:test": "npm run generate:api:test && ng serve --host=0.0.0.0 --configuration=test",
        "start:apitest": "npm run generate:api:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
        "start:localDev": "npm run generate:api:localDev && ng serve --host=0.0.0.0 --configuration=localDev",
        "start-sia": "npm run ng-openapi-gen-sia && ng serve --host=0.0.0.0",
        "start:sia:dev": "npm run generate:api:sia:dev && ng serve --host=0.0.0.0 --configuration=development",
        "start:sia:prod": "npm run generate:api:sia:prod && ng serve --host=0.0.0.0 --configuration=prod",
        "start:sia:test": "npm run generate:api:sia:test && ng serve --host=0.0.0.0 --configuration=test",
        "start:sia:apitest": "npm run generate:api:sia:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
        "build": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build",
        "build:dev": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build --configuration dev",
        "build:prod": "npm run ng-openapi-gen-all &&  node prebuild.js && ng build --configuration production",
        "build:test": "npm run generate:api:test && node prebuild.js && ng build --configuration test",
        "build:api-test": "npm run generate:api:apitest && node prebuild.js && ng build --configuration apitest",
        "generate:api-usage": "cd generate-api-usage && npm i && node index.js",
        "test": "ng test",
        "i18n:extract": "ngx-translate-extract -i ./src -o ./src/assets/i18n/de.json -o ./src/assets/i18n/en.json -f namespaced-json -s -n --format-indentation '    '",
        "e2e": "ng e2e",
        "format:write": "prettier --write \"src/**/*{.ts,.json,.css,.scss,.html}\"",
        "cypress:start": "npm run generate:api:dev && ng serve",
        "cypress:open": "cypress open",
        "cypress:run": "cypress run",
        "cypress:wait-on": "wait-on http://localhost:4200 && cypress:run",
        "cypress:test": "start-server-and-test cypress:start http://localhost:4200 cypress:run"
    },
    "private": true,
    "dependencies": {
        "@almothafar/angular-signature-pad": "^5.0.1",
        "@angular-eslint/schematics": "^20.2.0",
        "@angular/animations": "^20.2.2",
        "@angular/cdk": "^20.2.1",
        "@angular/common": "^20.2.2",
        "@angular/compiler": "^20.2.2",
        "@angular/core": "^20.2.2",
        "@angular/forms": "^20.2.2",
        "@angular/material": "^20.2.1",
        "@angular/material-luxon-adapter": "^20.2.1",
        "@angular/material-moment-adapter": "^20.2.1",
        "@angular/platform-browser": "^20.2.2",
        "@angular/platform-browser-dynamic": "^20.2.2",
        "@angular/router": "^20.2.2",
        "@messageformat/core": "^3.3.0",
        "@ngneat/dialog": "^5.0.0",
        "@ngneat/overview": "^6.0.0",
        "@ngneat/until-destroy": "^10.0.0",
        "@ngrx/store": "^20.0.1",
        "@ngrx/store-devtools": "^20.0.1",
        "@ngx-formly/bootstrap": "^6.3.2",
        "@ngx-formly/core": "^6.3.2",
        "@ngx-translate/core": "^15.0.0",
        "@ngx-translate/http-loader": "^8.0.0",
        "@zxing/browser": "0.1.5",
        "@zxing/library": "^0.21.0",
        "@zxing/ngx-scanner": "^20.0.0",
        "angular-oauth2-oidc": "^20.0.2",
        "axios": "^1.7.9",
        "blob-util": "^2.0.2",
        "bootstrap": "^5.3.3",
        "dayjs": "^1.11.11",
        "dls-frontend": "file:",
        "heic2any": "^0.0.4",
        "html-to-image": "^1.11.11",
        "luxon": "^3.4.4",
        "magic-bytes.js": "^1.10.0",
        "material-symbols": "^0.18.0",
        "moment": "^2.30.1",
        "ng-http-caching": "^20.0.1",
        "ng-qrcode": "^20.0.0",
        "ng-table-virtual-scroll": "^1.6.1",
        "ngx-extended-pdf-viewer": "^22.3.9",
        "ngx-mat-select-search": "^7.0.6",
        "ngx-skeleton-loader": "^9.0.0",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "ngx-translate-messageformat-compiler": "^7.0.0",
        "node-fetch": "^3.3.2",
        "prettier": "^3.2.5",
        "rxjs": "~7.8.1",
        "signature_pad": "^5.0.2",
        "uuidv4": "^6.2.13",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-eslint/builder": "^20.2.0",
        "@angular-eslint/eslint-plugin": "^20.2.0",
        "@angular-eslint/eslint-plugin-template": "^20.2.0",
        "@angular-eslint/template-parser": "^20.2.0",
        "@angular/build": "^20.2.1",
        "@angular/cli": "^20.2.1",
        "@angular/compiler-cli": "^20.2.2",
        "@bartholomej/ngx-translate-extract": "^8.0.2",
        "@ngx-formly/schematics": "^6.3.2",
        "@types/imap": "^0.8.40",
        "@types/jasmine": "~5.1.4",
        "@types/luxon": "^3.4.2",
        "@types/node": "^20.17.16",
        "@typescript-eslint/eslint-plugin": "7.11.0",
        "@typescript-eslint/parser": "7.11.0",
        "autoprefixer": "^10.4.19",
        "cypress": "latest",
        "eslint": "^9.3.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-prettier": "^5.1.3",
        "imap": "^0.8.17",
        "jasmine-core": "^5.1.2",
        "jasmine-spec-reporter": "~7.0.0",
        "karma": "~6.4.3",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.1.0",
        "ng-openapi-gen": "^0.51.0",
        "npm-run-all": "^4.1.5",
        "postcss": "^8.4.38",
        "prettier-eslint": "^16.3.0",
        "prettier-plugin-tailwindcss": "^0.5.14",
        "start-server-and-test": "^2.0.3",
        "tailwindcss": "^3.4.3",
        "ts-node": "~10.9.2",
        "tslib": "^2.6.2",
        "typescript": "~5.9.2"
    }
}
